import { useState } from "react";
import { Alert, Box, Button, Container, Stack, TextField, Typography, Paper } from "@mui/material";
import marketingApi from "../api/marketingApi";

const defaultForm = {
  name: "",
  email: "",
  company: "",
  message: "",
};

export default function ContactPage() {
  const [form, setForm] = useState(defaultForm);
  const [submitState, setSubmitState] = useState({ loading: false, error: null, success: null });

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = {
      name: form.name.trim(),
      email: form.email.trim(),
      company: form.company.trim(),
      message: form.message.trim(),
    };
    if (!trimmed.name || !trimmed.email || !trimmed.company || !trimmed.message) {
      setSubmitState({ loading: false, error: "All fields are required.", success: null });
      return;
    }
    setSubmitState({ loading: true, error: null, success: null });
    try {
      await marketingApi.submitContact(trimmed);
      setSubmitState({
        loading: false,
        error: null,
        success: "Thanks for reaching out. We'll respond soon.",
      });
      setForm(defaultForm);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Unable to send your message. Please try again.";
      setSubmitState({ loading: false, error: detail, success: null });
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f7f9fc", minHeight: "100vh", py: { xs: 6, md: 10 } }}>
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
          <Typography variant="h5" fontWeight={800} gutterBottom>
            Contact Us
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Send a message to the ResourceNAV team.
          </Typography>
          {submitState.error && <Alert severity="error">{submitState.error}</Alert>}
          {submitState.success && <Alert severity="success">{submitState.success}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{ mt: 2 }}>
              <TextField
                label="Name"
                value={form.name}
                onChange={handleChange("name")}
                required
                fullWidth
              />
              <TextField
                label="Email"
                type="email"
                value={form.email}
                onChange={handleChange("email")}
                required
                fullWidth
              />
              <TextField
                label="Company"
                value={form.company}
                onChange={handleChange("company")}
                required
                fullWidth
              />
              <TextField
                label="Message"
                value={form.message}
                onChange={handleChange("message")}
                required
                fullWidth
                multiline
                minRows={4}
              />
              <Button type="submit" variant="contained" disabled={submitState.loading}>
                {submitState.loading ? "Sending..." : "Send message"}
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
